import { render, staticRenderFns } from "./driverTable.vue?vue&type=template&id=58d50d2a&"
import script from "./driverTable.vue?vue&type=script&lang=js&"
export * from "./driverTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports